import type { AdminSettingsStatus } from "../page";

interface SettingsPanelProps {
  status: AdminSettingsStatus;
  loading: boolean;
}

const SettingsPanel = ({ status, loading }: SettingsPanelProps) => {
  const rows = [
    { label: "애플리케이션", value: status.version?.application },
    { label: "버전", value: status.version?.applicationVersion },
    { label: "릴리즈 ID", value: status.version?.releaseId },
    { label: "Git commit", value: status.version?.gitCommit },
    { label: "빌드 시각", value: status.version?.builtAt },
  ];

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-blue-50"><i className="ri-server-line text-blue-600 text-xs" /></div>
          <h3 className="text-sm font-semibold text-slate-800">API 릴리즈 정보</h3>
        </div>
        <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-slate-50 border border-slate-200 text-xs font-medium text-slate-600">실시간 조회</span>
      </div>

      {loading ? (
        <div className="px-4 py-10 text-center text-xs text-slate-400">시스템 정보를 확인하는 중입니다.</div>
      ) : (
        <div className="flex flex-col divide-y divide-slate-100">
          {rows.map((row) => (
            <div key={row.label} className="grid grid-cols-[120px_minmax(0,1fr)] gap-3 py-3 text-xs">
              <span className="text-slate-400">{row.label}</span>
              <span className="font-medium text-slate-700 break-all">{row.value || "-"}</span>
            </div>
          ))}
        </div>
      )}

      <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3">
        <p className="text-xs text-blue-800 leading-relaxed" style={{ wordBreak: "keep-all" }}>
          API가 제공한 릴리즈 정보와 현재 인증된 관리자 정보를 그대로 표시합니다. 현재 로그인 관리자는 {status.admin?.loginId ?? "-"}입니다.
        </p>
      </div>
    </div>
  );
};

export default SettingsPanel;
